import { useSelector } from 'react-redux';
import ModalMobileNativeScroll from '../../atoms/ModalMobileNativeScroll';
import TypeCarModal from '../../atoms/TypeCarModal';
import Modal from '../../atoms/Modal';
import VoucherModalContent from '../../molecules/VoucherModalContent';
import PackageCarModal from '../../atoms/PackageCarModal';
import DiscountTermsModalContent from '../../molecules/DiscountTermsModalContent';
import { useState } from 'react';
import ModalTermsServices from '../../molecules/ModalTermsServices';

const ModalServiceDetailOptions = ({
  viewTypeCar,
  showVoucherModal,
  showTermsModal,
  viewPackageCarModal,
  setShowVoucherModal,
  setShowTermsModal,
  setViewPackageCarModal,
  setViewTypeCar,
  showTermsModalTnc,
  setShowTermsModalTnc,
  termCondition,
  serviceProductList,
  serviceType,
  serviceContent,
  serviceProductTitle,
  triggerGTM,
  isCMS = false,
  serviceDiscounts,
  bodyTypeName,
  feature = '',
  impressionData,
}: any) => {
  const { isMobileScreen } = useSelector((state: any) => state.page);
  const [indexVoucher, setIndexVoucher] = useState(0);

  const handleCloseTermsModal = () => {
    setShowTermsModal(false);
    setShowVoucherModal(true);
  };

  return (
    <>
      {/* Choose Car Type Modal */}
      {isMobileScreen ? (
        // Modal for mobile
        <ModalMobileNativeScroll
          visible={viewTypeCar}
          height={'h-screen'}
          title="TIPE MOBIL"
          bodyClassName="p-4"
          scrollBehaviour={true}
          onClose={() => setViewTypeCar(false)}
        >
          <div className="text-center  flex flex-col items-center">
            <TypeCarModal
              serviceProductList={serviceProductList}
              setViewTypeCar={setViewTypeCar}
              serviceType={serviceType}
              serviceProductTitle={serviceProductTitle}
              triggerGTM={triggerGTM}
              bodyTypeName={bodyTypeName}
            />
          </div>
        </ModalMobileNativeScroll>
      ) : (
        // Modal for desktop
        <Modal
          header={true}
          title="TIPE MOBIL"
          headerTitleClassName="text-xl !font-bold text-reliableBlack"
          bodyClassName="w-[520px] h-[540px] overflow-y-auto no-scrollbar max-h-[80vh] z-[100] px-5 py-6"
          visible={viewTypeCar}
          onClose={() => setViewTypeCar(false)}
        >
          <div className="text-center  flex flex-col items-center">
            <TypeCarModal
              serviceProductList={serviceProductList}
              setViewTypeCar={setViewTypeCar}
              serviceType={serviceType}
              serviceProductTitle={serviceProductTitle}
              triggerGTM={triggerGTM}
              bodyTypeName={bodyTypeName}
              serviceContent={undefined}
              titleCoupon={''}
            />
          </div>
        </Modal>
      )}

      {/* Voucher content modal */}
      {isMobileScreen ? (
        <ModalMobileNativeScroll
          title="Voucher Promo"
          visible={showVoucherModal}
          height={'h-screen'}
          scrollBehaviour={true}
          onClose={() => setShowVoucherModal(false)}
          bodyClassName={'px-2'}
        >
          <VoucherModalContent
            voucherList={serviceDiscounts}
            setShowVoucherModal={setShowVoucherModal}
            setIndexVoucher={setIndexVoucher}
            handleShowTerms={setShowTermsModal}
            serviceContent={serviceContent}
            feature={feature}
            impressionData={impressionData}
          />
        </ModalMobileNativeScroll>
      ) : (
        <Modal
          header={true}
          title="Voucher Promo"
          className="w-[622px]"
          headerTitleClassName="text-xl !font-bold text-reliableBlack"
          bodyClassName="max-h-[80vh]"
          visible={showVoucherModal}
          onClose={() => setShowVoucherModal(false)}
        >
          <VoucherModalContent
            voucherList={serviceDiscounts}
            setShowVoucherModal={setShowVoucherModal}
            setIndexVoucher={setIndexVoucher}
            handleShowTerms={setShowTermsModal}
            serviceContent={serviceContent}
            feature={feature}
            impressionData={impressionData}
          />
        </Modal>
      )}

      {/* Voucher terms modal */}
      {isMobileScreen ? (
        <ModalMobileNativeScroll
          title={serviceDiscounts?.[indexVoucher]?.name}
          visible={showTermsModal}
          height={'h-screen'}
          onClose={handleCloseTermsModal}
          scrollBehaviour={true}
          showBackButton={true}
          showCloseButton={false}
        >
          <div className="text-center flex flex-col items-center mt-4">
            <DiscountTermsModalContent data={serviceDiscounts?.[indexVoucher]} />
          </div>
        </ModalMobileNativeScroll>
      ) : (
        <Modal
          header={true}
          title={serviceDiscounts?.[indexVoucher]?.name}
          headerTitleClassName="text-xl !font-bold text-reliableBlack"
          bodyClassName="w-[622px] overflow-y-auto no-scrollbar max-h-[80vh] px-0 py-8"
          visible={showTermsModal}
          onClose={handleCloseTermsModal}
        >
          <div className="text-center flex flex-col items-center !my-[-12px]">
            <DiscountTermsModalContent data={serviceDiscounts?.[indexVoucher]} />
          </div>
        </Modal>
      )}

      {/* Choose Package Modal */}
      <ModalMobileNativeScroll
        visible={viewPackageCarModal}
        title={serviceType === 'coupon' ? 'KUPON SERVIS' : 'PAKET SERVIS'}
        height="h-[70vh]"
        bodyClassName="h-full"
        onClose={() => setViewPackageCarModal(false)}
      >
        <div className="h-full flex flex-col justify-start items-center">
          <PackageCarModal
            serviceType={serviceType}
            closeModal={() => setViewPackageCarModal(false)}
            serviceProductTitle={serviceProductTitle}
            bodyTypeName={bodyTypeName}
            serviceContent={undefined}
            feature={feature}
            impressionData={impressionData}
          />
        </div>
      </ModalMobileNativeScroll>
      <ModalTermsServices
        visible={showTermsModalTnc}
        setVisible={setShowTermsModalTnc}
        termsCondition={termCondition}
        showAgreeButton={serviceType === 'accessories'}
      />
    </>
  );
};

export default ModalServiceDetailOptions;
